/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import cometList from '../../../../Fct/plugins/compoundv3/helpers/cometList.json';
export var AccountData = createPlugin({
    protocol: 'COMPOUND_V3',
    type: 'GETTER',
    method: 'userBasic',
    description: 'The protocol tracks data like the principal and indexes for each account that supplies and borrows.',
    supportedContracts: cometList,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                account: new FctAddress({}),
            },
        },
        output: {
            pricinpal: new FctValue({ innerIndex: 0 }),
            baseTrackingIndex: new FctValue({ innerIndex: 1 }),
            baseTrackingAccrued: new FctValue({ innerIndex: 2 }),
            assetsIn: new FctValue({ innerIndex: 3 }),
        },
    }); },
});
